import React, { FunctionComponent } from "react";
import {  
  Table,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import { useTableStyles } from "../../useTableStyle";
import { useUserLogStyles } from "../useUserLogStyles";
import { ThemeProvider } from "@mui/material/styles";

interface userlogProps {
  users: any;
  storeusers: any;
}

export const UserLogList: FunctionComponent<userlogProps> = ({
  users,
  storeusers,
}) => {
  const getMuiTheme = useTableStyles();
  const classes = useUserLogStyles();
  const columns = [
    "Name",
    "Url",
    "Authenticated By",
    "Logged date and time",
    "",
  ];

  const options = {
    selectableRows: undefined,
    selectableRowsHeader: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    display: true,
    responsive: undefined,
    fixedHeaderOptions: {
      xAxis: true,
      yAxis: true,
    },
    isRowSelectable: function () {
      return false;
    },
    customRowRender: (data: any) => {
      return (
        <TableRow className={classes.tableRow} onClick={() => {}}>
          <TableCell>
            <Typography className={classes.tableCell}>{data[0]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[1]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[2]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{data[3]}</Typography>
          </TableCell>
          <TableCell>
            <Typography className={classes.tableCell}>{""}</Typography>
          </TableCell>
        </TableRow>
      );
    },
  };

  return (
    <Table>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          title={"User Log"}
          data={users?.map((user: any) => {
            const storeuser =
              storeusers &&
              storeusers.find((item: any) => item.id === user?.user_id);
            const user_name = storeuser?.full_name;
            return [
              user_name,
              user.url,
              user.authenticated_by,
              moment(user.created_at).format("DD/MM/YYYY  h:mm:ss A"),
            ];
          })}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </Table>
  );
};
